import * as Headless from "@headlessui/react";
import clsx from "clsx";
import { ReactElement } from "react";

import { textColors, textSizes, TypographyProps } from "../../config/tailwind";

interface LegendProps
  extends Omit<Headless.LegendProps, "as" | "className" | "color">,
    Pick<TypographyProps, "color" | "size"> {
  className?: string;
}

export const Legend = ({
  className,
  color = "default",
  size = "base",
  ...props
}: LegendProps): ReactElement => (
  <Headless.Legend
    className={clsx(
      "select-none font-semibold",
      textSizes[size],
      textColors[color],
      "data-[disabled]:opacity-50",
      className,
    )}
    data-slot="legend"
    {...props}
  />
);
